<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      
      <b-row>
        <b-col class="d-flex justify-content-between" cols="12">
          <h3> {{ mainTitle }} </h3>
          
          <feather-icon
            size="20"
            class="cursor-pointer"
            @click="modalOpen = false"
            icon="XIcon"
          />
        </b-col>
      </b-row>
      <hr />
      
      <b-skeleton v-if="working" width="100%" height="900px"></b-skeleton>
      <div v-else>
        
        <b-row>
          <b-col cols="12">
            <info-card label="اسم المنظمة الدولية"
              :value="IOrganisationsMemberShips.name"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="الدولة"
              :value="IOrganisationsMemberShips.country ? IOrganisationsMemberShips.country.name : ''"
            />
          </b-col>
          <b-col cols="12">
            <info-card label=" العنوان"
              :value="IOrganisationsMemberShips.address"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="مجال عمل المنظمة الدولية"
              :value="IOrganisationsMemberShips.field_of_work"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="أهداف المنظمة الدولية"
              :value="IOrganisationsMemberShips.international_organization_goals"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="كافة البيانات المتوفرة لدى المنظمة غير حكومية حول المنظمة لدولية"
              :value="IOrganisationsMemberShips.international_organization_data"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-2">
            <h5>
              المُرفقات :
            </h5>
          </b-col>
          <b-col cols="12">
            
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  صورة عن الدعوة الموجهة للمنظمة الغير حكومية من قبل المنظمة الدولية للانضمام 
                </div>
                <div>
                  <b-button

                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:IOrganisationsMemberShips.invitation_doc } }"
                  >
                    <feather-icon icon="EyeIcon"
                    /></b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  صك إحداث المنظمة الدولية 
                </div>
                <div>
                  <b-button

                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:IOrganisationsMemberShips.charter_doc } }"
                  >
                    <feather-icon icon="EyeIcon"/>
                  </b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
          
          <b-col cols="12">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  النظام الداخلي للمنظة الدولية 
                </div>
                <div>
                  <b-button

                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:IOrganisationsMemberShips.internal_system_doc } }"
                  >
                    <feather-icon icon="EyeIcon"
                    /></b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>

          <b-col cols="12">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  كتاب مُقدم من المنظمة الدولية يوضح فيه أعضاء إدارتها و أنشطتها و أماكن انتشارها و مصادر تمويلها وأعضاء المنظمة 
                </div>
                <div>
                  <b-button

                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:IOrganisationsMemberShips.activities_and_funding_doc } }"
                  >
                    <feather-icon icon="EyeIcon"
                    /></b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>

          <b-col cols="12">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  صور جوازات سفر أعضاء إدارة المنظمة الدولية 
                </div>
                <div>
                  <b-button

                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:IOrganisationsMemberShips.passports_doc } }"
                  >
                    <feather-icon icon="EyeIcon"/>
                  </b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton , BSidebar , BSkeleton } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import InfoCard from "@/components/InfoCard.vue";
const initForm = { id : null};
export default {
  data() {
    return {
      form: {},
    }
  },
  components: {
    BCard, BImg , BCol , InfoCard , BRow , BButton , BSidebar , BSkeleton
  },
  computed:{
    ...mapGetters("UNCoop", [
      "IOrganisationsMemberShips", "working"
    ]),
    
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  props: {
    value: Boolean,
    data : Object ,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات الطلب",
    },
    id: {
      type: Number,
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  watch: {
    async modalOpen(newVal) {
      if(newVal){

        console.log("id" , this.form)
         await this.fetchIOrganisationsMemberShips(this.form.id).then(()=> {
        });
      }
    },
  },
  methods:{
    ...mapActions("UNCoop", [
      "fetchIOrganisationsMemberShips",
    ]),
    getLableType(type){
      switch (type){
        case 'bank_donations':
          return 'تبرع مالي'
        case 'in_kind_donations':
          return 'تبرع عيني'
        case 'machines':
          return 'تبرع مركبة'
        default:
          return ''
      }
    },
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    getLableType(type){
      switch (type){
        case 'bank_donations':
          return 'تبرع مالي'
        case 'in_kind_donations':
          return 'تبرع عيني'
        case 'machines':
          return 'تبرع مركبة'
        default:
          return ''
      }
    },
  },

  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
};
</script>